/**
 * STEPS TOKENS
 * Source: 🔧 Custom — not defined in Figma component tokens
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createStepsTokens(s: SemanticTokens) {
  return {
  /** Base spacing and sizing for the steps component */
  base: {
    paddingX: s.layout.padding.md,  // --steps-base-padding-x: var(--spacing-48) = 48px
    paddingY: s.layout.gap.md,      // --steps-base-padding-y: var(--spacing-16) = 16px
    gap: '10px',                    // --steps-base-gap: gap between circle and label
    numberSize: s.layout.gap.xl,    // --steps-base-number-size: 2rem (32px) circle
    numberRadius: '9999px',         // --steps-base-number-radius: fully rounded
    borderWidth: '1px',             // --steps-base-border-width
    transitionDuration: s.transition.normal, // --steps-base-transition-duration
  },
  number: {
    fontSize: s.typography.fontSize.base,     // --steps-number-font-size
    fontWeight: s.typography.fontWeight.bold,  // --steps-number-font-weight
    fontFamily: s.typography.fontFamily.base,  // --steps-number-font-family
    lineHeight: s.typography.lineHeight.xl,    // --steps-number-line-height
  },
  label: {
    fontFamily: s.typography.fontFamily.base,  // --steps-label-font-family
    fontSize: s.typography.fontSize.sm,        // --steps-label-font-size
    fontWeight: s.typography.fontWeight.normal, // --steps-label-font-weight
    lineHeight: s.typography.lineHeight.lg,    // --steps-label-line-height
  },
  /** Container */
  bg: s.surface.ground,             // --steps-bg: var(--surface-ground)
  border: s.border.divider,         // --steps-border: var(--border-divider) — separator line & bottom border
  /** Number circle — default state */
  numberBg: s.surface.raised,       // --steps-number-bg: var(--surface-raised) = #e7e8ec
  numberFg: s.text.secondary,       // --steps-number-fg: var(--text-secondary) = #08183a
  /** Number circle — active state */
  numberBgActive: s.text.tertiary,  // --steps-number-bg-active: var(--text-tertiary) = #212f4e
  numberFgActive: s.text.onColor,   // --steps-number-fg-active: var(--text-on-color) = white
  /** Label — same color for default and active */
  labelFg: s.text.secondary,        // --steps-label-fg: var(--text-secondary) = #08183a
  };
}
export const stepsTokens = createStepsTokens(SEMANTIC);